// extracted by mini-css-extract-plugin
export default {"wrapper":"phone-number_wrapper__aTw3o","error":"phone-number_error__QBPq1"};